module.exports = __webpack_public_path__ + "static/media/author6.a3641071.jpg";